import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ServiceReport from "../../../bao-cao-thong-ke/components/ServiceReport";
import ProfileReport from "../../../bao-cao-thong-ke/components/ProfileReport";
import FinancialReport from "../../../bao-cao-thong-ke/components/FinancialReport";
import IntellectualPropertyReport from "../../../bao-cao-thong-ke/components/IntellectualPropertyReport";

const TabReportInfo = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("service");

  const tabs = [
    { id: "service", label: "Báo cáo dịch vụ" },
    { id: "profile", label: "Báo cáo hồ sơ" },
    { id: "intellectual-property", label: "Danh mục tài sản trí tuệ" },
    { id: "financial", label: "Báo cáo tài chính" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "service":
        return <ServiceReport clientId={id} />;
      case "profile":
        return <ProfileReport clientId={id} />;
      case "intellectual-property":
        return <IntellectualPropertyReport clientId={id} />;
      case "financial":
        return <FinancialReport clientId={id} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex gap-4 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-8 py-2.5 text-sm font-semibold transition-all rounded-lg ${
              activeTab === tab.id
                ? "bg-blue-600 text-white shadow-md"
                : "bg-blue-50 text-blue-600 hover:bg-blue-100"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-auto">{renderTabContent()}</div>
    </div>
  );
};

export default TabReportInfo;
